module.exports = __webpack_public_path__ + "img/7b397b9.jpg";